import PropTypes from "prop-types";
import React from "react";
import { intlShape } from "react-intl";
import { Loader, Button } from "cxa-components";
import FormHeading from "components/common/FormHeading";
import messages from "components/messagesDescription";
import ClaimSubmissionForm, { formName } from "./ClaimSubmissionForm";
import ClaimItemAccountsWidget from "./ClaimItemAccountsWidget";

class AddClaimPage extends React.Component {
  componentDidMount() {
    const {
      loadBenefitPlans,
      loadClaimItems,
      loadClaimItemAccounts,
      loadShouldDisplayClaimItemsFields,
      claimTypeId,
      benefitPeriod,
      selectedDelegator,
      mode,
      loadClaimItemFields,
      getDonateCategory,
    } = this.props;

    loadBenefitPlans();
    loadClaimItems(benefitPeriod, false, selectedDelegator, getDonateCategory);
    loadClaimItemAccounts(benefitPeriod, claimTypeId, selectedDelegator);
    loadShouldDisplayClaimItemsFields();
    loadClaimItemFields(
      benefitPeriod,
      claimTypeId,
      undefined,
      mode,
      selectedDelegator,
      getDonateCategory
    );
  }

  componentDidUpdate(prevProps) {
    const {
      loadClaimLimitMessages,
      loadClaimItemFields,
      claimTypeId,
      benefitPeriod,
      claimantId,
      claimantType,
      receiptDate,
      mode,
      selectedDelegator,
      getDonateCategory,
    } = this.props;

    if (prevProps.claimTypeId !== claimTypeId || prevProps.benefitPeriod != benefitPeriod) {
      loadClaimItemFields(
        benefitPeriod,
        claimTypeId,
        undefined,
        mode,
        selectedDelegator,
        getDonateCategory
      );
    }

    if (
      this.props.claimantType &&
      this.props.receiptDate &&
      (prevProps.claimantType !== this.props.claimantType ||
        prevProps.receiptDate !== this.props.receiptDate ||
        prevProps.claimantId !== this.props.claimantId)
    ) {
      loadClaimLimitMessages(claimantId, claimantType, claimTypeId, receiptDate, selectedDelegator);
    }
  }

  render() {
    const { isFetching } = this.props;

    if (isFetching) {
      return <Loader />;
    }

    const {
      headers,
      rows,
      accountsExhausted,
      benefitPlan,
      claimItem,
      claimInstruction,
      fields,
      intl,
      onCancel,
      getDonateCategory,
    } = this.props;
    const pageTitle = intl.formatMessage(
      getDonateCategory ? messages.newDonationDescription : messages.newClaimDescription
    );
    const planName = benefitPlan && benefitPlan.planName;
    const claimName =
      claimItem &&
      intl.formatMessage({
        id: claimItem.claimName,
        defaultMessage: claimItem.claimName,
      });
    const claimItemLabel =
      fields &&
      intl.formatMessage({
        id: fields.claimItemType.label,
        defaultMessage: fields.claimItemType.label,
      });
    const taxStatus = claimItem.isTaxable
      ? intl.formatMessage(messages.taxableDescription)
      : intl.formatMessage(messages.nonTaxableDescription);
    const taxStatusLabel =
      fields &&
      fields.taxStatus &&
      intl.formatMessage({
        id: fields.taxStatus.label,
        defaultMessage: fields.taxStatus.label,
      });

    const infoFields = [
      {
        label: intl.formatMessage(messages.benefitPlanDescription),
        value: planName,
        id: "planName",
      },
      {
        label: claimItemLabel,
        value: claimName,
        id: "claimName",
      },
      {
        label: taxStatusLabel,
        value: taxStatus,
        id: "taxStatus",
      },
    ];

    const defaultValues =
      fields &&
      fields.fields.reduce((obj, field) => {
        if (field.default) {
          return {
            ...obj,
            [field.name]: field.default,
          };
        } else {
          return { ...obj };
        }
      }, {});

    const initialValues = {
      ...this.props.initialValues,
      ...defaultValues,
    };
    return (
      <div className="cxa-grid__wrapper apl-grid--wrapped">
        <div className="cxa-grid__item cxa-grid__item--six">
          {accountsExhausted ? (
            <article className="card">
              <section>
                <FormHeading title={pageTitle} fields={infoFields} />
                <p>{intl.formatMessage(messages.accountExhaustedDescription)}</p>
              </section>
            </article>
          ) : (
            <ClaimSubmissionForm {...this.props} initialValues={initialValues} />
          )}
          {accountsExhausted && (
            <Button primary type="button" onClick={onCancel}>
              {intl.formatMessage(messages.backButtonDescription)}
            </Button>
          )}
        </div>
        <div className="cxa-grid__item cxa-grid__item--six">
          {!accountsExhausted && <ClaimItemAccountsWidget headers={headers} rows={rows} />}
          {claimInstruction && (
            <p
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({
                  id: claimInstruction,
                  defaultMessage: claimInstruction,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

AddClaimPage.propTypes = {
  headers: PropTypes.array,
  rows: PropTypes.array,
  loadBenefitPlans: PropTypes.func,
  loadClaimItems: PropTypes.func,
  loadClaimItemFields: PropTypes.func,
  loadShouldDisplayClaimItemsFields: PropTypes.func,
  claimTypeId: PropTypes.string,
  isFetching: PropTypes.bool,
  loadClaimLimitMessages: PropTypes.func,
  loadClaimItemAccounts: PropTypes.func,
  benefitPlan: PropTypes.any,
  claimItem: PropTypes.any,
  fields: PropTypes.any,
  login: PropTypes.object,
  onCancel: PropTypes.func,
  claimInstruction: PropTypes.string,
  accountsFetching: PropTypes.bool,
  accountsExhausted: PropTypes.bool,
  benefitPeriod: PropTypes.string,
  claimantId: PropTypes.any,
  claimantType: PropTypes.any,
  receiptDate: PropTypes.any,
  intl: intlShape.isRequired,
  changeReferralFileName: PropTypes.func,
  mode: PropTypes.string,
  selectedDelegator: PropTypes.number,
  getDonateCategory: PropTypes.bool,
};

export default AddClaimPage;
export { formName };



// WEBPACK FOOTER //
// ./components/claim/AddClaimPage.js